<template>
  <el-card>
    <el-row class="user-sign__title"> 用户标签 </el-row>

    <!-- 搜索表单 -->
    <SearchForm
      :signTypeList="signTypeList"
      :channelList="channelList"
      :countryList="countryList"
      :signTemplateList="signTemplateList"
      @search="handleSearch"
      @create="handleCreate"
    />

    <!-- 复核表单 -->
    <ReviewForm :signTypeList="signTypeList" @review="handleReview" />

    <!-- 复核弹窗 -->
    <el-dialog
      :visible.sync="reviewDialog"
      title="复核结果"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="review-dialog"
    >
      <div class="review-container">
        <!-- 标签列表 -->
        <div class="review-section">
          <h3 class="section-title">
            <i class="el-icon-tickets"></i>
            相关标签
          </h3>
          <div class="tag-list">
            <el-tag
              v-for="item in reviewList.signList"
              :key="item"
              type="primary"
              size="medium"
              class="tag-item"
            >
              {{ item }}
            </el-tag>
          </div>
        </div>

        <!-- 复核日志 -->
        <div class="review-section">
          <h3 class="section-title">
            <i class="el-icon-document"></i>
            复核日志
          </h3>
          <div class="log-content">
            <div
              v-for="(line, idx) in reviewList.log
                ? reviewList.log.split('\n')
                : []"
              :key="idx"
              class="log-line"
            >
              <i class="el-icon-info log-icon"></i>
              <span v-html="highlightLog(line)"></span>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reviewDialog = false">确定</el-button>
      </div>
    </el-dialog>

    <!-- 表格 -->
    <UserSignTable
      :userSignList="userSignList"
      :totalPage="totalPage"
      :pageSize="pageSize"
      :currentPage="currentPage"
      @edit="handleEdit"
      @copy="handleCopy"
      @delete="handleDelete"
      @changeValid="handleChangeValid"
      @currentChange="handleCurrentChange"
    />

    <!-- 弹出框 -->
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="userSignDialog"
    >
      <el-row
        style="
          font-size: 20px;
          text-align: center;
          font-weight: bold;
          color: #000;
        "
      >
        {{ type === 1 ? '修改' : '新建' }}角色标签
      </el-row>

      <!-- 基础信息 -->
      <el-row class="dialogItem">
        <span>标签名称</span>
        <el-input v-model="list.name" style="width: 400px"></el-input>
      </el-row>
      <el-row class="dialogItem">
        <span>分类</span>
        <el-select
          v-model="list.signType"
          style="width: 400px"
          filterable
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in signTypeList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-row>
      <el-row class="dialogItem">
        <span>渠道</span>
        <el-checkbox v-model="list.isChannel" style="margin-right: 10px"
          >排除渠道</el-checkbox
        >
        <el-select
          v-model="list.channel"
          style="width: 400px"
          filterable
          multiple
          collapse-tags
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in channelList"
            :key="item.channelId"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row class="dialogItem">
        <span>国家</span>
        <el-checkbox v-model="list.isCountry" style="margin-right: 10px"
          >排除国家</el-checkbox
        >
        <div style="display: flex; flex-direction: column; gap: 10px; width: 400px;">
          <el-select
            v-model="list.countryCode"
            filterable
            multiple
            collapse-tags
            clearable
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in countryList"
              :key="item.countryCode"
              :label="item.country"
              :value="item.countryCode"
            >
            </el-option>
          </el-select>
          <div style="display: flex; gap: 10px; align-items: center;">
            <el-input
              v-model="countryCodeInput"
              placeholder="粘贴逗号分割的国家代码，如: US,CN,JP"
              style="flex: 1"
              @keyup.enter.native="addCountryCodes"
            ></el-input>
            <el-button type="primary" size="small" @click="addCountryCodes">添加</el-button>
          </div>
        </div>
      </el-row>
      <el-row class="dialogItem">
        <span>模板</span>
        <el-select
          v-model="list.signTemplate"
          style="width: 400px"
          filterable
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in signTemplateList"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-row>

      <!-- 用户模板 -->
      <UserTemplate
        v-if="list.signTemplate === 'user'"
        :userData="user"
        :userChannelList="userChannelList"
        :vipLevelList="vipLevelList"
        :phoneModels="phoneModels"
        :isLevel="isLevel"
        :isPhoneModels="isPhoneModels"
        @changeDate="changeDate"
        @changeIsPhoneModels="changeIsPhoneModels"
      />

      <!-- 主播模板 -->
      <HostTemplate
        v-else-if="list.signTemplate === 'host'"
        :anchorData="anchor"
        :isAgentId.sync="list.isAgentId"
        :isExcludeAnchorId.sync="isExcludeAnchorId"
        @changeDate="changeDate"
        @addAnchorId="addAnchorId"
      />

      <!-- 机器人模板 -->
      <RobotTemplate
        v-else-if="list.signTemplate === 'robot'"
        :robotData="robot"
        @changeDate="changeDate"
      />

      <!-- 新主播模板 -->
      <NewHostTemplate
        v-else-if="list.signTemplate === 'new_host'"
        :newHostData="newHost"
        :hostStatus="hostStatus"
        @changeDate="changeDate"
      />

      <!-- 公共字段 -->
      <el-row class="dialogItem property-config-item">
        <span>属性配置</span>
        <div class="property-config-container">
          <PropertyConfig
            v-model="list.propertyJson"
            :countryList="countryList"
            :langList="langList"
          />
        </div>
      </el-row>
      <el-row class="dialogItem">
        <span>备注信息</span>
        <el-input
          type="textarea"
          v-model="list.remark"
          style="width: 400px"
        ></el-input>
      </el-row>
      <el-row class="dialogItem">
        <span>优先级</span>
        <el-input v-model="list.priority" style="width: 400px"></el-input>
      </el-row>
      <el-row class="dialogItem">
        <el-button @click="cancle">取消</el-button>
        <el-button @click="submitInfo">确认</el-button>
      </el-row>
    </el-dialog>

    <!-- 主播ID管理 -->
    <AnchorIdManager
      :visible="isShowAnchorId"
      :anchorIdList="anchorIdList"
      @addId="addAnchorIdToList"
      @removeId="removeAnchorIdFromList"
      @removeIds="removeAnchorIds"
      @cancel="cancelAnchorId"
      @confirm="confirmAnchorId"
    />
  </el-card>
</template>

<script>
import SearchForm from '@/components/UserSign/SearchForm.vue'
import ReviewForm from '@/components/UserSign/ReviewForm.vue'
import UserSignTable from '@/components/UserSign/UserSignTable.vue'
import UserTemplate from '@/components/UserSign/UserTemplate.vue'
import HostTemplate from '@/components/UserSign/HostTemplate.vue'
import RobotTemplate from '@/components/UserSign/RobotTemplate.vue'
import NewHostTemplate from '@/components/UserSign/NewHostTemplate.vue'
import AnchorIdManager from '@/components/UserSign/AnchorIdManager.vue'
import PropertyConfig from '@/components/UserSign/SortConfig.vue'
import UserSignAPI from '@/components/UserSign/api.js'
import {
  splitToArray,
  parseTimeToTimestamp,
  processSpecialValue,
  formatList,
} from '@/components/UserSign/utils.js'

export default {
  name: 'UserSign',
  components: {
    SearchForm,
    ReviewForm,
    UserSignTable,
    UserTemplate,
    HostTemplate,
    RobotTemplate,
    NewHostTemplate,
    AnchorIdManager,
    PropertyConfig,
  },
  data() {
    return {
      isPhoneModels: false,
      // API服务实例
      api: null,

      // 复核相关
      reviewDialog: false,
      reviewList: {
        log: '',
        signList: [],
      },

      // 搜索相关
      searchList: {
        signType: '',
        channel: '',
        countryCode: '',
        signTemplate: '',
        valid: '',
        name: null,
      },

      // 基础数据
      isLevel: true,
      isShowAnchorId: false,
      anchorIdList: [],
      isExcludeAnchorId: false,

      // 修改/新增标签
      list: {
        name: '',
        isChannel: false,
        isCountry: false,
        isAgentId: false,
        signType: '',
        countryCode: '',
        signTemplate: '',
        valid: 0,
        channel: '',
        remark: '',
        propertyJson: '',
        priority: '',
      },

      // 用户标签列表
      userSignList: [],

      // 主播模板
      anchor: {
        greenHost: null,
        firstProbationHost: null,
        continuousGreenHosts: null,
        hasOfflineVideo: null,
        isNewHost: null,
        beautifulHost: null,
        potentialHost:null,
        bSideHost: null,
        phase: null,
        userGroup: '',
        agentId: '',
        sex: '',
        appraiseLevel: ['', ''],
        hostMonthLevel: ['', ''],
        matchCallStartRate: ['', ''],
        registerTime: '',
        positiveTime: '',
        lostTime: '',
        verSymbol: 1,
        verLimit: '',
      },

      // 机器人模板
      robot: {
        sex: '',
        userGroup: '',
        appraiseLevel: ['', ''],
        hadOfflineVideo: '',
      },

      // 用户来源渠道列表
      userChannelList: [
        { name: '全部', value: 0 },
        { name: '自然注册', value: 1 },
        { name: '推广渠道', value: 2 },
      ],

      // 会员等级
      vipLevelList: ['vip1', 'vip2', 'vip3'],

      // 用户模板
      user: {
        sex: '',
        userGroup: '',
        vip: '',
        pay: '',
        registerSource: 0,
        memberGrade: '',
        newByRegister: '',
        newByRegisterSymbol: 1,
        lastRechargeTimeSymbol: 1,
        lastRechargeTime: '',
        recentRechargeDays: '',
        verSymbol: 1,
        verLimit: '',
        consumeGold: ['', ''],
        rechargeAmount: ['', ''],
        rechargeGold: ['', ''],
        recentRechargeUsd: ['', ''],
        registerTime: '',
        lostTime: '',
      },

      // 新主播模板
      newHost: {
        phase: '',
        registerDays: ['', ''],
        positiveDays: ['', ''],
      },

      // 选项列表
      hostStatus: [],
      signTypeList: [],
      channelList: [],
      countryList: [],
      langList: [],
      signTemplateList: [],
      phoneModels: [],

      // 弹窗和分页
      userSignDialog: false,
      totalPage: 10,
      currentPage: 1,
      pageSize: 30,
      type: 0,

      // 国家代码输入
      countryCodeInput: '',
    }
  },
  mounted() {
    this.api = new UserSignAPI(this.$axios, this.$store)
    this.getAllList()
    this.getUserSigns(1)
    this.getPhoneModels()
  },
  methods: {
    changeIsPhoneModels(newVal) {
      this.isPhoneModels = newVal
    },
    // 搜索相关方法
    handleSearch(searchData) {
      this.searchList = searchData
      this.getUserSigns(1)
    },

    handleCreate() {
      this.userSigns(0)
    },

    // 复核相关方法
    async handleReview(reviewData) {
      if (reviewData.rid && reviewData.signType) {
        try {
          const res = await this.api.reviewQuery(reviewData)
          if (res.code != 0) {
            return this.$message.error(res.msg)
          } else {
            this.reviewDialog = true
            this.reviewList = res.data
          }
        } catch (error) {
          this.$message.error('复核查询失败')
        }
      } else {
        return this.$message.warning('rid或分类不能为空')
      }
    },

    // 表格相关方法
    handleEdit(row) {
      this.userSigns(1, row)
    },

    handleCopy(row) {
      let info = JSON.parse(JSON.stringify(row))
      info.name = ''
      info.id = ''
      this.userSigns(1, info)
    },

    async handleDelete(id) {
      if (!id) return this.$message.warning('用户id不存在')

      try {
        const res = await this.api.deleteUserSign(id)
        if (res.code != 0) {
          return this.$message.error(res.msg)
        } else {
          this.$message.success('删除成功')
          this.getUserSigns()
        }
      } catch (error) {
        this.$message.error('删除失败')
      }
    },

    async handleChangeValid(row) {
      const userInfo = JSON.parse(JSON.stringify(row))
      userInfo.valid = Math.abs(row.valid - 1)
      await this.updateUserSigns(userInfo)
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.getUserSigns(page)
    },

    // 获取数据方法
    async getUserSigns(page) {
      let curPage = page || this.currentPage

      try {
        const res = await this.api.getUserSigns(this.searchList, curPage)
        if (res.code != 0) {
          return this.$message.error(res.msg)
        } else {
          this.userSignList = res.data.list
          this.totalPage = res.data.total
        }
      } catch (error) {
        this.$message.error('获取用户标签列表失败')
      }
    },

    async getAllList() {
      await Promise.all([
        this.getSignType(),
        this.getChannel(),
        this.getCountryCode(),
        this.getLang(),
        this.getSignTemplate(),
        this.getHostType(),
      ])
    },

    async getSignType() {
      try {
        const res = await this.api.getSignType()
        if (res.code != 0) {
          return this.$message.error(res.msg)
        } else {
          this.signTypeList = res.data
        }
      } catch (error) {
        this.$message.error('获取分类列表失败')
      }
    },

    async getHostType() {
      try {
        const res = await this.api.getHostType()
        if (res.code != 0) {
          return this.$message.error(res.msg)
        } else {
          this.hostStatus = res.data
        }
      } catch (error) {
        this.$message.error('获取主播阶段失败')
      }
    },

    async getChannel() {
      try {
        const res = await this.api.getChannel()
        if (res.code != 0) {
          return this.$message.error(res.msg)
        } else {
          this.channelList = [
            { channelId: -1, name: 'all', value: 'all' },
            ...res.data,
          ]
        }
      } catch (error) {
        this.$message.error('获取渠道列表失败')
      }
    },

    async getCountryCode() {
      try {
        const res = await this.api.getCountryCode()
        if (res.code != 0) {
          return this.$message.error(res.msg)
        } else {
          this.countryList = res.data.countryList
        }
      } catch (error) {
        this.$message.error('获取国家列表失败')
      }
    },

    async getLang() {
      try {
        const { data: res } = await this.$axios({
          method: 'POST',
          url: this.$store.getters.path.langList,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
        })

        if (res.code != 0) {
          return this.$message.error(res.msg)
        } else {
          this.langList = res.data
        }
      } catch (error) {
        this.$message.error('获取语言列表失败')
      }
    },

    async getSignTemplate() {
      try {
        const res = await this.api.getSignTemplate()
        if (res.code != 0) {
          return this.$message.error(res.msg)
        } else {
          this.signTemplateList = res.data
        }
      } catch (error) {
        this.$message.error('获取模板列表失败')
      }
    },

    async getPhoneModels() {
      // try {
      //   const res = await this.api.getPhoneModels()
      //   if (res.code != 0) {
      //     return this.$message.error(res.msg)
      //   } else {
      //     this.phoneModels = res.data.modelNameList
      //   }
      // } catch (error) {
      //   this.$message.error('获取手机型号列表失败')
      // }
      this.phoneModels = [
        { label: 'iPhone (Original)', value: 'iPhone1,1' },
        { label: 'iPhone 3G', value: 'iPhone1,2' },
        { label: 'iPhone 3GS', value: 'iPhone2,1' },
        { label: 'iPhone 4 (GSM)', value: 'iPhone3,1' },
        { label: 'iPhone 4 (GSM Rev A)', value: 'iPhone3,2' },
        { label: 'iPhone 4 (CDMA)', value: 'iPhone3,3' },
        { label: 'iPhone 4S', value: 'iPhone4,1' },
        { label: 'iPhone 5 (GSM)', value: 'iPhone5,1' },
        { label: 'iPhone 5 (GSM+CDMA)', value: 'iPhone5,2' },
        { label: 'iPhone 5C (GSM)', value: 'iPhone5,3' },
        { label: 'iPhone 5C (Global)', value: 'iPhone5,4' },
        { label: 'iPhone 5S (GSM)', value: 'iPhone6,1' },
        { label: 'iPhone 5S (Global)', value: 'iPhone6,2' },
        { label: 'iPhone 6', value: 'iPhone7,2' },
        { label: 'iPhone 6 Plus', value: 'iPhone7,1' },
        { label: 'iPhone 6S', value: 'iPhone8,1' },
        { label: 'iPhone 6S Plus', value: 'iPhone8,2' },
        { label: 'iPhone SE (1st gen)', value: 'iPhone8,4' },
        { label: 'iPhone 7 (Global)', value: 'iPhone9,1' },
        { label: 'iPhone 7 Plus (Global)', value: 'iPhone9,2' },
        { label: 'iPhone 7 (GSM)', value: 'iPhone9,3' },
        { label: 'iPhone 7 Plus (GSM)', value: 'iPhone9,4' },
        { label: 'iPhone 8 (Global)', value: 'iPhone10,1' },
        { label: 'iPhone 8 Plus (Global)', value: 'iPhone10,2' },
        { label: 'iPhone X (Global)', value: 'iPhone10,3' },
        { label: 'iPhone 8 (GSM)', value: 'iPhone10,4' },
        { label: 'iPhone 8 Plus (GSM)', value: 'iPhone10,5' },
        { label: 'iPhone X (GSM)', value: 'iPhone10,6' },
        { label: 'iPhone XS', value: 'iPhone11,2' },
        { label: 'iPhone XS Max', value: 'iPhone11,4' },
        { label: 'iPhone XS Max (China)', value: 'iPhone11,6' },
        { label: 'iPhone XR', value: 'iPhone11,8' },
        { label: 'iPhone 11', value: 'iPhone12,1' },
        { label: 'iPhone 11 Pro', value: 'iPhone12,3' },
        { label: 'iPhone 11 Pro Max', value: 'iPhone12,5' },
        { label: 'iPhone SE (2nd gen)', value: 'iPhone12,8' },
        { label: 'iPhone 12 mini', value: 'iPhone13,1' },
        { label: 'iPhone 12', value: 'iPhone13,2' },
        { label: 'iPhone 12 Pro', value: 'iPhone13,3' },
        { label: 'iPhone 12 Pro Max', value: 'iPhone13,4' },
        { label: 'iPhone 13 mini', value: 'iPhone14,4' },
        { label: 'iPhone 13', value: 'iPhone14,5' },
        { label: 'iPhone 13 Pro', value: 'iPhone14,2' },
        { label: 'iPhone 13 Pro Max', value: 'iPhone14,3' },
        { label: 'iPhone SE (3rd gen)', value: 'iPhone14,6' },
        { label: 'iPhone 14', value: 'iPhone14,7' },
        { label: 'iPhone 14 Plus', value: 'iPhone14,8' },
        { label: 'iPhone 14 Pro', value: 'iPhone15,2' },
        { label: 'iPhone 14 Pro Max', value: 'iPhone15,3' },
        { label: 'iPhone 15', value: 'iPhone15,4' },
        { label: 'iPhone 15 Plus', value: 'iPhone15,5' },
        { label: 'iPhone 15 Pro', value: 'iPhone16,1' },
        { label: 'iPhone 15 Pro Max', value: 'iPhone16,2' },
        { label: 'iPhone 16', value: 'iPhone17,3' },
        { label: 'iPhone 16 Plus', value: 'iPhone17,4' },
        { label: 'iPhone 16 Pro', value: 'iPhone17,1' },
        { label: 'iPhone 16 Pro Max', value: 'iPhone17,2' },
        { label: 'iPhone 16e', value: 'iPhone17,5' },
      ]
    },

    // 新建或修改
    userSigns(type, info = {}) {
      this.type = type
      let data = JSON.parse(JSON.stringify(info))
      data.isCountry = false
      data.isChannel = false

      // 处理 data 的逻辑
      if (type !== 0) {
        data.countryCode = splitToArray(data.countryCode, ',', 2)
        data.channel = splitToArray(data.channel, ',', 2)
        data.countryCode = processSpecialValue(
          data.countryCode,
          (flag) => (data.isCountry = flag)
        )
        data.channel = processSpecialValue(
          data.channel,
          (flag) => (data.isChannel = flag)
        )
        this.isPhoneModels = false
      }

      // 处理 type === 1 的逻辑
      if (type === 1) {
        this.list = JSON.parse(JSON.stringify(data))

        // 确保propertyJson字段存在
        if (!this.list.propertyJson) {
          this.list.propertyJson = ''
        }

        let signData
        try {
          signData = JSON.parse(this.list.signJson)
        } catch (err) {
          this.list.signJson = '{}'
          return
        }

        switch (this.list.signTemplate) {
          case 'user':
            this.parseUserSignData(signData)
            break
          case 'host':
            this.parseHostSignData(signData)
            break
          case 'robot':
            this.parseRobotSignData(signData)
            break
          case 'new_host':
            this.parseNewHostSignData(signData)
            break
          default:
        }
      }
      this.userSignDialog = true
    },

    // 以下是各类型的解析函数
    parseUserSignData(signData) {
      if (
        signData &&
        typeof signData === 'object' &&
        Object.keys(signData).length > 0
      ) {
        // 处理数据
        let processedUser = { ...signData }
        if (processedUser.newByRegister) {
          processedUser.newByRegister =
            processedUser.newByRegister / 60 / 60 / 24
        }
        if (processedUser.lastRechargeTime) {
          processedUser.lastRechargeTime = processedUser.lastRechargeTime * 1000
        }

        processedUser.phoneModels = splitToArray(
          processedUser.phoneModels,
          ';',
          2
        )

        if (processedUser.phoneModels.length > 0 && processedUser.phoneModels[0].includes('-')) {
          this.isPhoneModels = true
          processedUser.phoneModels[0] = processedUser.phoneModels[0].slice(1)
        }

        processedUser.consumeGold = splitToArray(processedUser.consumeGold, '-')
        processedUser.rechargeAmount = splitToArray(
          processedUser.rechargeAmount,
          '-'
        )
        processedUser.rechargeGold = splitToArray(
          processedUser.rechargeGold,
          '-'
        )
        processedUser.recentRechargeUsd = splitToArray(
          processedUser.recentRechargeUsd,
          '-'
        )
        processedUser.registerTime = parseTimeToTimestamp(
          processedUser.registerTime
        )

        // 使用 $set 确保响应式更新
        Object.keys(processedUser).forEach((key) => {
          this.$set(this.user, key, processedUser[key])
        })
      } else {
        this.user = this.getDefaultUser()
      }
    },
    getDefaultUser() {
      return {
        sex: '',
        userGroup: '',
        vip: '',
        pay: '',
        registerSource: 0,
        memberGrade: '',
        newByRegister: '',
        newByRegisterSymbol: 1,
        lastRechargeTimeSymbol: 1,
        lastRechargeTime: '',
        recentRechargeDays: '',
        verSymbol: 1,
        verLimit: '',
        consumeGold: ['', ''],
        rechargeAmount: ['', ''],
        rechargeGold: ['', ''],
        recentRechargeUsd: ['', ''],
        registerTime: '',
        lostTime: '',
      }
    },
    parseHostSignData(signData) {
      if (signData && typeof signData === 'object') {
        // 处理数据
        let processedAnchor = { ...signData }

        // 处理 agentId
        if (
          processedAnchor.agentId &&
          processedAnchor.agentId.charAt(0) === '-'
        ) {
          this.$set(this.list, 'isAgentId', true)
          processedAnchor.agentId = processedAnchor.agentId.substring(1)
        }

        // 处理 userGroup (主播ID列表) 的负号
        if (processedAnchor.userGroup) {
          const userGroupStr = processedAnchor.userGroup.toString()
          // 检查是否包含负号
          if (userGroupStr.includes('-')) {
            this.isExcludeAnchorId = true
          } else {
            this.isExcludeAnchorId = false
          }
        } else {
          this.isExcludeAnchorId = false
        }

        processedAnchor.appraiseLevel = splitToArray(
          processedAnchor.appraiseLevel,
          '-'
        )
        processedAnchor.hostMonthLevel = splitToArray(
          processedAnchor.hostMonthLevel,
          '-'
        )
        processedAnchor.matchCallStartRate = splitToArray(
          processedAnchor.matchCallStartRate,
          '-'
        )
        processedAnchor.registerTime = parseTimeToTimestamp(
          processedAnchor.registerTime
        )
        processedAnchor.positiveTime = parseTimeToTimestamp(
          processedAnchor.positiveTime
        )
        // if (processedAnchor.certificateType) {
        //   if (processedAnchor.certificateType.includes(',')) {
        //     processedAnchor.certificateType = processedAnchor.certificateType.split(',').map(item => +item)
        //   } else {
        //     processedAnchor.certificateType = [+processedAnchor.certificateType]
        //   }
        // } else {
        //   processedAnchor.certificateType = []
        // }

        // 使用 $set 确保响应式更新
        Object.keys(processedAnchor).forEach((key) => {
          this.$set(this.anchor, key, processedAnchor[key])
        })

        // 处理主播ID列表，保留负号用于显示
        if (processedAnchor.userGroup) {
          const userGroupStr = processedAnchor.userGroup.toString()
          this.anchorIdList = userGroupStr.includes(',')
            ? userGroupStr.split(',').map(id => parseInt(id.trim()))
            : [parseInt(processedAnchor.userGroup)]
        } else {
          this.anchorIdList = []
        }
      } else {
        this.anchor = this.getDefaultAnchor()
        this.anchorIdList = []
      }
    },
    getDefaultAnchor() {
      return {
        greenHost: null,
        firstProbationHost: null,
        continuousGreenHosts: null,
        hasOfflineVideo: null,
        isNewHost: null,
        beautifulHost: null,
        potentialHost: null,
        bSideHost: null,
        phase: null,
        userGroup: '',
        agentId: '',
        sex: '',
        appraiseLevel: ['', ''],
        hostMonthLevel: ['', ''],
        matchCallStartRate: ['', ''],
        registerTime: '',
        positiveTime: '',
        lostTime: '',
        verSymbol: 1,
        verLimit: '',
      }
    },
    parseRobotSignData(signData) {
      if (
        signData &&
        typeof signData === 'object' &&
        Object.keys(signData).length > 0
      ) {
        let processedRobot = { ...signData }
        processedRobot.appraiseLevel = splitToArray(
          processedRobot.appraiseLevel,
          '-'
        )

        // 使用 $set 确保响应式更新
        Object.keys(processedRobot).forEach((key) => {
          this.$set(this.robot, key, processedRobot[key])
        })
      } else {
        this.robot = this.getDefaultRobot()
      }
    },
    getDefaultRobot() {
      return {
        sex: '',
        userGroup: '',
        appraiseLevel: ['', ''],
        hadOfflineVideo: '',
      }
    },
    parseNewHostSignData(signData) {
      if (
        signData &&
        typeof signData === 'object' &&
        Object.keys(signData).length > 0
      ) {
        let processedNewHost = { ...signData }
        processedNewHost.phase = splitToArray(processedNewHost.phase)
        processedNewHost.registerDays = splitToArray(
          processedNewHost.registerDays,
          '-'
        )
        processedNewHost.positiveDays = splitToArray(
          processedNewHost.positiveDays,
          '-'
        )

        // 使用 $set 确保响应式更新
        Object.keys(processedNewHost).forEach((key) => {
          this.$set(this.newHost, key, processedNewHost[key])
        })
      } else {
        this.newHost = this.getDefaultNewHost()
      }
    },
    getDefaultNewHost() {
      return {
        phase: ['', ''],
        registerDays: ['', ''],
        positiveDays: ['', ''],
      }
    },

    // 取消
    cancle() {
      this.isPhoneModels = false
      Object.keys(this.list).forEach((key) => (this.list[key] = ''))
      this.list.isChannel = false
      this.list.isCountry = false
      this.list.isAgentId = false
      this.list.propertyJson = ''
      this.anchorIdList = []
      this.countryCodeInput = ''

      // 重置 user 对象
      Object.keys(this.user).forEach((key) => {
        if (key === 'verSymbol' || key === 'newByRegisterSymbol' || key === 'lastRechargeTimeSymbol') {
          this.$set(this.user, key, 1)
        } else if (typeof this.user[key] !== 'object' || key == 'registerTime') {
          this.$set(this.user, key, '')
        } else {
          this.$set(this.user, key, ['', ''])
        }
      })

      // 重置 anchor 对象
      Object.keys(this.anchor).forEach((key) => {
        if (key === 'verSymbol') {
          this.$set(this.anchor, key, 1)
        } else if (
          typeof this.anchor[key] !== 'object' ||
          key == 'registerTime' ||
          key == 'positiveTime'
        ) {
          this.$set(this.anchor, key, '')
        } else {
          this.$set(this.anchor, key, ['', ''])
        }
      })

      // 重置 robot 对象
      Object.keys(this.robot).forEach((key) => {
        if (typeof this.robot[key] !== 'object') {
          this.$set(this.robot, key, '')
        } else {
          this.$set(this.robot, key, ['', ''])
        }
      })

      // 重置 newHost 对象
      Object.keys(this.newHost).forEach((key) => {
        if (typeof this.newHost[key] !== 'object') {
          this.$set(this.newHost, key, '')
        } else {
          this.$set(this.newHost, key, ['', ''])
        }
      })

      this.userSignDialog = false
    },

    // 工具函数：将数组或逗号分隔字符串转为过滤后的字符串
    normalizeToString(val) {
      if (Array.isArray(val)) {
        return val.filter((item) => item !== '').toString()
      }
      if (typeof val === 'string' && val !== '') {
        return val
          .split(',')
          .filter((item) => item !== '')
          .toString()
      }
      return ''
    },

    // 提交信息
    submitInfo() {
      let arr = {
        name: '标签名称',
        signType: '分类',
        countryCode: '国家',
        signTemplate: '模板',
        channel: '渠道',
      }
      let data = {}
      let cjson = ''
      for (let i in arr) {
        if (this.list[i] == '') {
          return this.$message.warning(`提交失败，${arr[i]}不能为空`)
        }
      }
      if (this.list.signTemplate === 'user') {
        if (this.user.newByRegister) {
          this.user.newByRegister = this.user.newByRegister * 24 * 60 * 60
        }
        if (this.user.lastRechargeTime) {
          this.user.lastRechargeTime = this.user.lastRechargeTime / 1000
        }
        if (this.user.phoneModels) {
          this.user.phoneModels = this.user.phoneModels.join(';')
          if (this.isPhoneModels) {
            this.user.phoneModels = '-' + this.user.phoneModels
          }
        }

        cjson = JSON.stringify(formatList(this.user))
      } else if (this.list.signTemplate === 'host') {
        if (this.list.isAgentId) {
          this.anchor.agentId = '-' + this.anchor.agentId
        }
        // 处理主播ID列表的负号
        console.log(this.anchor.userGroup)
        if (this.anchor.userGroup) {
          if (typeof this.anchor.userGroup === 'string') {
            const ids = this.anchor.userGroup.split(',').map(id => {
              const trimmedId = id.trim();
              const numId = parseInt(trimmedId);
              
              if (isNaN(numId)) {
                return trimmedId; // 非数字ID保持原样
              }
              
              // 根据当前排除状态决定是否添加负号
              if (this.isExcludeAnchorId) {
                // 如果当前勾选了排除，确保有负号
                return numId < 0 ? numId : -numId;
              } else {
                // 如果当前没有勾选排除，确保没有负号
                return Math.abs(numId);
              }
            });
            
            this.anchor.userGroup = ids.join(',');
          }
        }
        console.log(this.anchor.userGroup)
        // this.anchor.certificateType = this.anchor.certificateType.toString()
        cjson = JSON.stringify(formatList(this.anchor))
      } else if (this.list.signTemplate === 'robot') {
        cjson = JSON.stringify(formatList(this.robot))
      } else if (this.list.signTemplate === 'new_host') {
        this.newHost.phase = this.newHost.phase.toString()
        cjson = JSON.stringify(formatList(this.newHost))
      }
      // 使用工具函数处理
      this.list.countryCode = this.normalizeToString(this.list.countryCode)
      this.list.channel = this.normalizeToString(this.list.channel)
      data = { ...this.list, signJson: cjson }
      this.updateUserSigns(data)
    },

    // 修改用户标签
    async updateUserSigns(data) {
      let userInfo = JSON.parse(JSON.stringify(data))
      if (this.list.isChannel) {
        userInfo.channel = '-' + userInfo.channel
      }
      if (this.list.isCountry) {
        userInfo.countryCode = '-' + userInfo.countryCode
      }

      try {
        const res = await this.api.updateUserSigns(userInfo)
        if (res.code != 0) {
          return this.$message.error(res.msg)
        } else {
          this.$message.success('修改成功')
          this.cancle()
          this.getUserSigns()
        }
      } catch (error) {
        this.$message.error('修改失败')
      }
    },

    // 主播ID管理相关方法
    addAnchorId() {
      this.isShowAnchorId = true
      // 不需要在这里设置 isExcludeAnchorId，因为它是通过 .sync 双向绑定的
    },

    addAnchorIdToList(id) {
      this.anchorIdList.push(id)
    },

    removeAnchorIdFromList(index) {
      this.anchorIdList.splice(index, 1)
    },

    removeAnchorIds(ids) {
      const idSet = new Set(
        (ids || [])
          .map(id => parseInt(id))
          .filter(id => !isNaN(id))
      )
      if (!idSet.size) return
      const before = this.anchorIdList.length
      this.anchorIdList = this.anchorIdList.filter(id => !idSet.has(parseInt(id)))
      const removed = before - this.anchorIdList.length
      const missed = idSet.size - removed
      this.$message.success(`已删除 ${removed} 个ID${missed > 0 ? `，${missed} 个未找到` : ''}`)
    },

    cancelAnchorId() {
      this.isShowAnchorId = false
    },

    confirmAnchorId(userGroup) {
      this.anchor.userGroup = userGroup
      console.log(this.anchor.userGroup)
      this.isShowAnchorId = false
    },

    // 添加国家代码
    addCountryCodes() {
      if (!this.countryCodeInput || !this.countryCodeInput.trim()) {
        return this.$message.warning('请输入国家代码')
      }

      // 解析输入的值：按逗号分割，去除空格
      const inputCodes = this.countryCodeInput
        .split(',')
        .map(code => code.trim())
        .filter(code => code !== '')

      if (inputCodes.length === 0) {
        return this.$message.warning('请输入有效的国家代码')
      }

      // 确保 list.countryCode 是数组
      if (!Array.isArray(this.list.countryCode)) {
        this.list.countryCode = []
      }

      // 直接添加新值，去重处理
      const addedCodes = []
      const duplicateCodes = []

      inputCodes.forEach(inputCode => {
        // 避免重复添加
        if (!this.list.countryCode.includes(inputCode)) {
          this.list.countryCode.push(inputCode)
          addedCodes.push(inputCode)
        } else {
          duplicateCodes.push(inputCode)
        }
      })

      // 清空输入框
      this.countryCodeInput = ''

      // 显示结果提示
      if (addedCodes.length > 0) {
        this.$message.success(`成功添加 ${addedCodes.length} 个国家代码`)
      }
      if (duplicateCodes.length > 0) {
        this.$message.warning(`以下国家代码已存在，已跳过: ${duplicateCodes.join(', ')}`)
      }
    },

    // 其他方法
    changeDate() {
      this.$forceUpdate()
    },

    highlightLog(line) {
      // 先匹配"匹配失败"和"匹配成功"，再匹配单独的词
      let html = line
        .replace(/(匹配失败)/g, '<span class="log-warn">$1</span>')
        .replace(/(匹配成功)/g, '<span class="log-success">$1</span>')
        .replace(/(失败|不匹配|错误|异常)/g, '<span class="log-warn">$1</span>')
        .replace(/(成功)/g, '<span class="log-success">$1</span>')
      return html
    },
  },
}
</script>

<style scoped lang="scss">
.user-sign {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }
}

.card {
  margin: 20px 0;
}

.dialogItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  text-align: left;
  padding-left: 50px;
  color: #000;

  > span {
    width: 160px;
    margin-right: 10px;
    text-align: right;
    font-size: 15px;
    font-weight: bold;

    &.to {
      width: 50px;
      text-align: center;
    }
  }
}

// 复核弹窗样式
:deep(.review-dialog) {
  .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px;

    .el-dialog__title {
      color: white;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__headerbtn {
      .el-dialog__close {
        color: white;
        font-size: 18px;

        &:hover {
          color: #f0f0f0;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 30px;
  }

  .el-dialog__footer {
    padding: 20px 30px;
    border-top: 1px solid #e4e7ed;
    background: #fafafa;
  }
}

.review-container {
  .review-section {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .section-title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin: 0 0 15px 0;
      padding-bottom: 10px;
      border-bottom: 2px solid #409eff;

      i {
        margin-right: 8px;
        color: #409eff;
        font-size: 18px;
      }
    }

    .tag-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .tag-item {
        margin: 0;
        border-radius: 20px;
        font-weight: 500;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
        }
      }
    }

    .log-content {
      background: #f8f9fa;
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      padding: 20px;
      max-height: 300px;
      overflow-y: auto;

      .log-line {
        display: flex;
        align-items: flex-start;
        font-size: 14px;
        line-height: 1.8;
        margin-bottom: 6px;
        word-break: break-all;
        .log-icon {
          color: #409eff;
          margin-right: 6px;
          font-size: 16px;
          flex-shrink: 0;
          margin-top: 2px;
        }
        .log-warn {
          color: #e67c73;
          font-weight: bold;
        }
        .log-success {
          color: #67c23a;
          font-weight: bold;
        }
      }
    }
  }
}

.dialog-footer {
  text-align: right;

  .el-button {
    padding: 12px 24px;
    font-size: 14px;
    border-radius: 6px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
    }
  }
}

:deep(.log-warn) {
  color: #e67c73 !important;
  font-weight: bold;
}
:deep(.log-success) {
  color: #67c23a !important;
  font-weight: bold;
}

.property-config-item {
  margin-top: 30px;
  text-align: left;
  padding-left: 50px;
  color: #000;

  > span {
    width: 160px;
    margin-right: 10px;
    text-align: right;
    font-size: 15px;
    font-weight: bold;

    &.to {
      width: 50px;
      text-align: center;
    }
  }
}

.property-config-container {
  width: 600px;
}
</style> 
